import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimize = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 1,
	viewBox: "0 0 11 1",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m11 0v1h-11v-1z",
		strokeWidth: .26208
	})
});
const Memo = memo(SvgMinimize);
export default Memo;
